export default __webpack_public_path__ + "static/hero_img-8bb5f36c515fc351c2181c73d8e5c9cb.jpg";